"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var domain = 'https://widget.intercom.io';
/* eslint-disable */

var loadScript = function loadScript() {
  if (window.Intercom) return;

  (function () {
    var w = window;
    var ic = w.Intercom;

    if (typeof ic === 'function') {
      ic('reattach_activator'); //eslint-disable-next-line no-undef

      ic('update', window.intercomSettings);
    } else {
      var d = document;

      var i = function i() {
        i.c(arguments);
      };

      i.q = [];

      i.c = function (args) {
        i.q.push(args);
      };

      w.Intercom = i; //eslint-disable-next-line no-inner-declarations

      var l = function l() {
        var _x$parentNode;

        var s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = "".concat(domain, "/widget/3qmk5gyg");
        var x = d.getElementsByTagName('script')[0];
        (_x$parentNode = x.parentNode) === null || _x$parentNode === void 0 ? void 0 : _x$parentNode.insertBefore(s, x);
      };

      l();
    }
  })();
};
/* eslint:enable */


var load = function load(_ref) {
  var providerKey = _ref.providerKey,
      setState = _ref.setState;
  loadScript();
  window.Intercom('boot', {
    app_id: providerKey
  });
  setTimeout(function () {
    return setState('complete');
  }, 2000);
};

var open = function open() {
  return window.Intercom('show');
};

var close = function close() {
  return window.Intercom('close');
};

var _default = {
  domain: domain,
  load: load,
  open: open,
  close: close
};
exports.default = _default;